import * as XLSX from 'xlsx-js-style'
import { applyStyles } from "./styles"
import { getWorkSheets } from './data'

export const exportMultipleGrids = (state) => {
    let workbook = XLSX.utils.book_new()
    let {
        wsNgl,
        wsButane,
        wsIsoButane,
        wsPropane,
        wsCondensate,
        wsNormalButane
    } = getWorkSheets(state)

    wsNgl = applyStyles(wsNgl, 'NGL')
    wsPropane = applyStyles(wsPropane, 'Propane')
    wsButane = applyStyles(wsButane, 'Butane')
    wsIsoButane = applyStyles(wsIsoButane, 'IsoButane')
    wsNormalButane = applyStyles(wsNormalButane, 'Normal Butane')
    wsCondensate = applyStyles(wsCondensate, 'Condensate')

    XLSX.utils.book_append_sheet(workbook, wsNgl, 'NGL')
    XLSX.utils.book_append_sheet(workbook, wsPropane, 'Propane')
    XLSX.utils.book_append_sheet(workbook, wsButane, 'Butane')
    XLSX.utils.book_append_sheet(workbook, wsIsoButane, 'IsoButane')
    XLSX.utils.book_append_sheet(workbook, wsNormalButane, 'Normal Butane')
    XLSX.utils.book_append_sheet(workbook, wsCondensate, 'Condensate')

    return workbook
}